<div class="main"><div class="left"><app-left-nav></app-left-nav></div><div class="content"><router-outlet></router-outlet></div></div>